// extracted by mini-css-extract-plugin
export default {"input":"inputsStyle_input__w7x1W","disabled":"inputsStyle_disabled__S8uIQ"};